import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { StringTMap } from 'src/app/core/models/common.models';
import { Importance } from 'src/app/core/models/importances.models';
import { ImportancesStoreService } from 'src/app/core/store/services/importances-store.service';

@Component({
  selector: 'craft-importance-label',
  templateUrl: './craft-importance-label.component.html',
  styleUrls: ['./craft-importance-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftImportanceLabelComponent extends Destroyer implements OnInit {
  @Input() public selectedId: string | undefined;
  public importances: Readonly<StringTMap<Importance>>;

  constructor(
    private cdr: ChangeDetectorRef,
    private importancesStore: ImportancesStoreService,
  ) {
    super();
  }

  public get name() {
    if (!this.selectedId) return '';
    return this.importances[this.selectedId]?.name || '';
  }

  public ngOnInit() {
    this.importancesStore.map$.pipe(takeUntil(this.destroy$)).subscribe((importances) => {
      this.importances = importances;
      this.cdr.detectChanges();
    });
  }
}
